import React from 'react';
import PropTypes from 'prop-types';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import BannerBar from '../../Common/NoticeBar/BannerBar';

const Banner = ({ noticeBar }) => (
  <div id="toolbar-notice-bar">
    <HousecallThemeProvider>
      <BannerBar
        message={noticeBar.display_message}
        type={noticeBar.bar_type}
        shouldShowBookDemo={noticeBar.show_book_demo_cta}
        shouldShowUpgrade={noticeBar.show_upgrade_cta}
        onBarClick={() => {
          window.location = noticeBar.direct_to_link;
        }}
      />
    </HousecallThemeProvider>
  </div>
);

Banner.propTypes = {
  noticeBar: PropTypes.shape({
    display_message: PropTypes.string,
    bar_type: PropTypes.string,
    show_book_demo_cta: PropTypes.bool,
    show_upgrade_cta: PropTypes.bool,
    direct_to_link: PropTypes.string,
  }).isRequired,
};

export default Banner;
